export const inYourLanguage: Record<
  string,
  { body: string; open: string; cancel: string; shorthand: string }
> = {
  en: {
    shorthand: "In En",
    body: "This page is available in English",
    open: "Go",
    cancel: "Don't ask again",
  },
}
